function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import QueryString from 'query-string';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { setIsUnderTechnicalReview } from '../store/features/reviewSlice';
import { useDispatch } from 'react-redux';
import { storeMultipleClaimProjectReports } from '../store/features/claimProjectReportsSlice';
import { buildQueryString, buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
const api = buildService('/claim_groups', {
  only: ['all']
});
const claimGroupService = {
  useFetchClaimGroupAndUpdateTechnicalReviewState(_ref) {
    let {
      claimGroupId,
      setClaimGroup,
      onFetched = null
    } = _ref;
    const dispatch = useDispatch();
    const fetchClaimGroupAndUpdateTechnicalReviewState = useErrorHandling(useCallback(async () => {
      if (claimGroupId) {
        const fetchedClaimGroup = await claimGroupService.get(claimGroupId);
        setClaimGroup(fetchedClaimGroup);
        onFetched && onFetched(fetchedClaimGroup);
        dispatch(setIsUnderTechnicalReview(!!fetchedClaimGroup.active_change_set));

        // "claim_project_reports" is not returned with the claim group. Not sure if this should be fixed or removed
        // https://github.com/Ayming-Digital-UK/rd-web-react/pull/871
        // dispatch(storeMultipleClaimProjectReports(!!fetchedClaimGroup.claim_project_reports))
      }
    }, [claimGroupId, dispatch, onFetched, setClaimGroup]));
    return fetchClaimGroupAndUpdateTechnicalReviewState;
  },
  // Refactoring to set the isUnderReview state on claim group fetch.
  // To replace get when the refactoring is done.
  useGetClaimGroup(claimGroupId) {
    let onFetched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const [claimGroup, setClaimGroup] = useState(initialState);
    const dispatch = useDispatch();
    const fetchClaimGroupAndUpdateTechnicalReviewState = claimGroupService.useFetchClaimGroupAndUpdateTechnicalReviewState({
      claimGroupId,
      setClaimGroup,
      onFetched
    });
    useEffect(() => {
      fetchClaimGroupAndUpdateTechnicalReviewState(claimGroupId);
    }, [fetchClaimGroupAndUpdateTechnicalReviewState, claimGroupId]);
    const resetClaimGroup = fetchClaimGroupAndUpdateTechnicalReviewState;
    return [claimGroup, setClaimGroup, resetClaimGroup];
  },
  useUpdateClaimGroup(_ref2) {
    let {
      setClaimGroup
    } = _ref2;
    return useErrorHandling(useCallback(async claimGroup => {
      const updatedClaimGroup = await claimGroupService.update(claimGroup);
      setClaimGroup(updatedClaimGroup);
    }, [setClaimGroup]));
  },
  useFetchAllClaimGroups(setLoading, initialQueryParams) {
    const [claimGroups, setClaimGroups, fetchClaimGroups] = serviceMethods.useFetch({
      callback: useCallback(async queryParams => {
        console.log('inside claimGroupService useFetchALlClaimGroups');
        const response = await api.all({
          query: buildQueryString(queryParams)
        });
        return response.claim_groups;
      }, []),
      setLoading,
      initialQueryParams: initialQueryParams || ''
    });
    return [claimGroups, setClaimGroups, fetchClaimGroups];
  },
  get(claimGroupId) {
    return fetch("/api/claim_groups/".concat(claimGroupId), request.get);
  },
  update(claim_group) {
    return fetch("/api/claim_groups/".concat(claim_group.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        claim_group
      })
    }));
  },
  create(claim_group) {
    return fetch('/api/claim_groups/', _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        claim_group
      })
    }));
  },
  all(params) {
    return fetch("/api/claim_groups?".concat(params), request.get);
  },
  delete(claimGroupId) {
    return fetch("/api/claim_groups/".concat(claimGroupId), _objectSpread({}, request.delete));
  }
};
export default claimGroupService;